/* global elementorFrontend, Swiper */
import $ from "jquery";

export const sliderTrainerTestimonials = () => {
  const el = {
    parent: ".ttm-wrapper",
  };

  if (!$(el.parent).length) return;

  const initSwiperForElement = function ($element) {
    var $swiperContainer = $element.find(".ttm-slider");
    if (!$swiperContainer.length) return;

    var params = {
      slidesPerView: 1,
      spaceBetween: 24,
      loop: false,
      watchOverflow: true,
      pagination: {
        el: $element.find(".ttm-pagination")[0],
        clickable: true,
      },
      navigation: {
        nextEl: $element.find(".ttm-next")[0],
        prevEl: $element.find(".ttm-prev")[0],
      },
      breakpoints: {
        600: {
          slidesPerView: 2,
          spaceBetween: 24,
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 24,
        },
      },
    };

    if (
      typeof elementorFrontend !== "undefined" &&
      elementorFrontend.utils &&
      elementorFrontend.utils.swiper
    ) {
      const asyncSwiper = elementorFrontend.utils.swiper;
      new asyncSwiper($swiperContainer, params).then(
        function (newSwiperInstance) {
          $swiperContainer.data("swiper", newSwiperInstance);
        },
      );
    } else if (typeof Swiper !== "undefined") {
      var newSwiper = new Swiper($swiperContainer[0], params);
      $swiperContainer.data("swiper", newSwiper);
    }
  };

  $(window).on("elementor/frontend/init", function () {
    if (typeof elementorFrontend !== "undefined" && elementorFrontend.hooks) {
      elementorFrontend.hooks.addAction(
        "frontend/element_ready/trainer-testimonials.default",
        function ($element) {
          initSwiperForElement($element);
        },
      );
    }
  });

  // Immediate initialization for non-Elementor or pre-initialized frontend pages
  // (e.g. this shortcode dropped into a normal single-trainer template)
  $(el.parent).each(function () {
    initSwiperForElement($(this));
  });
};

try {
  sliderTrainerTestimonials();
} catch (error) {
  console.warn(error);
}
